import { render, staticRenderFns } from "./expert-page.vue?vue&type=template&id=59cf6008&scoped=true"
import script from "./expert-page.vue?vue&type=script&lang=js"
export * from "./expert-page.vue?vue&type=script&lang=js"
import style0 from "./expert-page.vue?vue&type=style&index=0&id=59cf6008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf6008",
  null
  
)

export default component.exports